'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_NotScaledReason() {
}
export { $c_Lmealorama_NotScaledReason as $c_Lmealorama_NotScaledReason };
$p = $c_Lmealorama_NotScaledReason.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_NotScaledReason;
/** @constructor */
function $h_Lmealorama_NotScaledReason() {
}
export { $h_Lmealorama_NotScaledReason as $h_Lmealorama_NotScaledReason };
$h_Lmealorama_NotScaledReason.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=mealorama.-Not-Scaled-Reason.js.map
